import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { videosEdit_template } from "../components/templates/videosEdit_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class videos_edit extends vnModule_knockoutJS {
    protected editTemplate: videosEdit_template;
    protected pagination: pagination_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected saveXHRHdl: XMLHttpRequestHandler;

    protected getModuleName() {
        return "videos_edit";
    }

    public buildContent(): Array<Element> {
        this.editTemplate = new videosEdit_template("edit", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Videos List");

        return [this.editTemplate.build()];
    }

    public fillPage(): void {
        this.getVideoReferences();
        //this.getData();
    }

    protected getVideoReferences() {
        this.loadingIn(this.editTemplate.builtTemplate);
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/references";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetVideoReferences;
        this.XHRHdl.execute();
    }

    protected onGetVideoReferences(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                //console.log(responseParsed);
                let contentTypes = responseParsed.contentTypes;
                //contentTypes.unshift({ id: null, name: "Select an Option" });
                let subtitlesLanguages = responseParsed.languages;
                //subtitlesLanguages.unshift({ id: null, name: "Select an Option" });
                obj.getData();
                let contentTypeNames  = ["Trailer","Guide","Feature","News","List","Interview","Podcast","Review"];
                //loop through contentTypes and if name matches any of the content type names create new array
                let filteredContentTypes = [];
                for(let i=0;i<contentTypeNames.length;i++){
                    let contentType = contentTypeNames[i];
                    let option = contentTypes.find(x => x.name == contentType);
                    if(option){
                        filteredContentTypes.push(option);
                    }
                }
                obj.editTemplate.setContentTypes(filteredContentTypes);
                obj.editTemplate.setCategories(responseParsed.categories);
                obj.editTemplate.setSubtitlesLanguages(subtitlesLanguages);
            });
        };
    }

    protected getData() {
        this.loadingIn(this.editTemplate.builtTemplate);
        let brandId = this.getVnAppZone().app.params.idBrand;
        let videoId = this.getVnAppZone().app.params.id || 0;
        let usrReq_url: string = "/api/brand/" + brandId + "/videos/get/" + videoId;
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON(this.editTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetData;
        this.XHRHdl.execute();

        if (videoId === 0) {
            this.editTemplate.generateDropzone({});
            this.editTemplate.generateDropzoneSubtitles({});
            this.loadingOut(this.editTemplate.builtTemplate);
        }
    }

    protected onGetData(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setUpForm(responseParsed.data);
            });
            obj.loadingOut(obj.editTemplate.builtTemplate);
        };
    }

    public setUpForm(data): void {
        if (data.video && data.video.id) {
            let producer =
                data.video.details !== null && data.video.details.producer !== null
                    ? data.video.details.producer
                    : null;

            let idPrimaryTag =
                data.video.details !== null && data.video.details.idPrimaryTag !== null
                    ? data.video.details.idPrimaryTag
                    : null;

            let idPrimaryCategory =
                data.video.details !== null && data.video.details.idPrimaryCategory !== null
                    ? data.video.details.idPrimaryCategory
                    : null;

            let idContentType =
                data.video.details !== null && data.video.details.idContentType !== null
                    ? data.video.details.idContentType
                    : null;

            this.editTemplate.setId(data.video.id);
            this.editTemplate.setTitle(data.video.title);
            this.editTemplate.setDescription(data.video.description);
            this.editTemplate.setUrl(data.video.url);
            this.editTemplate.setLength(data.video.length);
            this.editTemplate.setSize(data.video.size);
            this.editTemplate.setSizeHuman(data.video.size);
            this.editTemplate.setHeight(data.video.height);
            this.editTemplate.setWidth(data.video.width);
            this.editTemplate.setRatio(data.video.ratio);
            this.editTemplate.setMimeType(data.video.mimeType);
            this.editTemplate.setDateCreated(data.video.dateCreated);
            this.editTemplate.setDateUpdated(data.video.dateUpdated);
            this.editTemplate.setProducer(producer);
            this.editTemplate.setThumbnail(data.video.thumbnail);
            this.editTemplate.setDetails(data.video.details !== null ? data.video.details : null);
            this.editTemplate.setIsUnderEmbargo(data.video.isUnderEmbargo);
            this.editTemplate.setLockItem(true);
            this.editTemplate.generateDropzone(data.video);
            this.editTemplate.imageWidgetForVideoThumbnail.setImage(data.video.thumbnail);
            this.editTemplate.generateDropzoneSubtitles(data.video);
            if (data.video.videoTags) {
                this.editTemplate.setSelectedTags(data.video.videoTags);
            }
            this.editTemplate.setIdPrimaryTag(idPrimaryTag);
            if (data.video.videoCategories) {
                this.editTemplate.setSelectedCategories(data.video.videoCategories);
            }
            this.editTemplate.setIdPrimaryCategory(idPrimaryCategory);
            this.editTemplate.setIdContentType(idContentType);
        }

        this.editTemplate.setPermissions(data.permissions);
        this.editTemplate.setHasAccessIsUnderEmbargo(data.hasAccessIsUnderEmbargo);
        this.editTemplate.setVideoArticleId(data.videoArticleId);
        this.editTemplate.setIdBunnyVideo(data.video.idBunnyVideo);
        this.editTemplate.setIdBunnyVideoPreview(data.video.idBunnyVideoPreview);
    }

    protected edit(id) {
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/edit/" + id);
    }

    public getSavePostData() {
        return {
            id: this.editTemplate.getTemplateViewModel().id(),
            description: this.editTemplate.getTemplateViewModel().description(),
            details: this.editTemplate.getTemplateViewModel().details(),
            height: this.editTemplate.getTemplateViewModel().height(),
            length: this.editTemplate.getTemplateViewModel().length(),
            mimeType: this.editTemplate.getTemplateViewModel().mimeType(),
            producer: this.editTemplate.getTemplateViewModel().producer(),
            idProducer: this.editTemplate.getTemplateViewModel().filterUser_producer.idUser(),
            ratio: this.editTemplate.getTemplateViewModel().ratio(),
            size: this.editTemplate.getTemplateViewModel().size(),
            thumbnail: this.editTemplate.getTemplateViewModel().thumbnail(),
            title: this.editTemplate.getTemplateViewModel().title(),
            url: this.editTemplate.getTemplateViewModel().url(),
            width: this.editTemplate.getTemplateViewModel().width(),
            isUnderEmbargo: this.editTemplate.getTemplateViewModel().isUnderEmbargo(),
            videoTags: this.editTemplate.getTemplateViewModel().selectedTags(),
            idPrimaryTag: this.editTemplate.getTemplateViewModel().idPrimaryTag(),
            idPrimaryCategory: this.editTemplate.getTemplateViewModel().idPrimaryCategory(),
            videoCategories: this.editTemplate.getTemplateViewModel().selectedCategories(),
            idContentType: this.editTemplate.getTemplateViewModel().idContentType(),
            videoSubtitles: this.editTemplate.getTemplateViewModel().subtitlesFiles(),
            idBunnyVideo: this.editTemplate.getTemplateViewModel().idBunnyVideo(),
            idBunnyVideoPreview: this.editTemplate.getTemplateViewModel().idBunnyVideoPreview()
        };
    }

    protected save() {
        if (this.saveXHRHdl) {
            return;
        }

        this.loadingIn(this.editTemplate.builtTemplate);

        let thumbnail = this.editTemplate.imageWidgetForVideoThumbnail.getImage();
        if (thumbnail) {
            this.editTemplate.imageWidgetForVideoThumbnail.setImage(thumbnail);
            this.editTemplate.setThumbnail(thumbnail);
        }

        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/save";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.getSavePostData())]);
        this.saveXHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.saveXHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.saveXHRHdl.onReadyStateFunction = this.onSave;
        this.saveXHRHdl.execute();
    }

    protected onSave(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            obj.saveXHRHdl = null;
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Video saved successfully!",
                );
                obj.redirectToListPage();
            });
            obj.loadingOut(obj.editTemplate.builtTemplate);
            if (req.request.status !== 200) {
                obj.editTemplate.enableSaveButtons();
            }
        };
    }

    protected getUploadUrl(): string {
        return "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/upload-single";
    }

    protected goBack() {
        let previousUrl = this.loadPreviousPage(window.location.href);
        if (previousUrl) {
            page.redirect(previousUrl);
        } else {
            page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos");
        }
    }

    public redirectToListPage() {
        //this.releaseLock();
        let previousUrl = this.loadPreviousPage(window.location.href);
        if (previousUrl) {
            page.redirect(previousUrl);
        } else {
            page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/videos");
        }
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) this.XHRHdl.cancelAndReset();
    }

    protected filterSimpleOnChange(idElement) {
        switch (idElement) {
            case "filterTag":
                this.editTemplate.updateSelectedTags();
                break;
            default:
        }
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls && requestName in this.XHRHdls) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    protected getUsersSuggestion(keyword) {
        let subViewModel = { list: { keyword: keyword }, idElement: "producerSave" };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestion;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestion(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.users) {
                    obj.editTemplate.setUsers(responseParsed.data.users);
                }
            });
        };
    }

    public getTagsSuggestion(keyword, idSourceElement) {
        this.filterSimpleCancel();
        let subViewModel = {
            filter: {
                keyword: keyword,
                limit: 5,
                tagType: null,
                getSelectable: true,
                getNonSelectable: false,
                imageAndSpecSelectable: false,
            },
        };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestion;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestion(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    obj.editTemplate.setTagFilterAutocomplete(responseParsed.data.tags);
                }
            });
        };
    }

    public filterMultipleSelectorOnChange() {
        this.editTemplate.updateSelectedCategories();
    }

    protected getUploadUrlSubtitles(): string {
        return "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/videos/subtitles/upload";
    }

    protected downloadSubtitle(url){
        window.open(url, '_blank');
    }

    public generateVideoArticle(data, videoArticleId) {

        //Grab the data from the previous template and open in new tab with the info
        let link : string  = "/brand/" + this.getVnAppZone().app.params.idBrand
        if(videoArticleId){
            link += "/articles/view/" +videoArticleId;
            window.open(link, "_blank");
        }else{
            //TODO : Grab the data from the view model and put that in a json object open in new tab
            link += "/articles/add?videoId="+data.id();
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["parameters", ko.toJSON(this.getSavePostData())]);

            // Open the URL in a new tab
            window.open(link, '_blank');
        }

    }
}



// WEBPACK FOOTER //
// ./js/modules/videos_edit.ts